import { apiClient } from "../../../lib";

export interface MundoHistoria {
  idMundoHistoria: number;
  nombre: string;
  descripcion?: string;
  icono?: string;
  color?: string;
  orden?: number;
}

export interface EtapaHistoria {
  idEtapaHistoria: number;
  nombre: string;
  mundoId: number;
  orden?: number;
  mundoOrden?: number;
}

export class GestionModoHistoriaService {
  // Mundos
  static async getMundos(): Promise<MundoHistoria[]> {
    const response = await apiClient.get("/modo-historia/mundos");
    return response.data.data || [];
  }

  static async createMundo(
    data: Omit<MundoHistoria, "idMundoHistoria">
  ): Promise<MundoHistoria> {
    const response = await apiClient.post("/modo-historia/mundos", data);
    return response.data.data;
  }

  static async updateMundo(
    id: number,
    data: Partial<MundoHistoria>
  ): Promise<MundoHistoria> {
    const response = await apiClient.put(`/modo-historia/mundos/${id}`, data);
    return response.data.data;
  }

  static async deleteMundo(id: number): Promise<void> {
    await apiClient.delete(`/modo-historia/mundos/${id}`);
  }

  // Etapas
  static async getEtapas(): Promise<EtapaHistoria[]> {
    const response = await apiClient.get("/modo-historia/etapas");
    return response.data.data || [];
  }

  static async createEtapa(
    data: Omit<EtapaHistoria, "idEtapaHistoria">
  ): Promise<EtapaHistoria> {
    const response = await apiClient.post("/modo-historia/etapas", data);
    return response.data.data;
  }

  static async updateEtapa(
    id: number,
    data: Partial<EtapaHistoria>
  ): Promise<EtapaHistoria> {
    const response = await apiClient.put(`/modo-historia/etapas/${id}`, data);
    return response.data.data;
  }

  static async deleteEtapa(id: number): Promise<void> {
    await apiClient.delete(`/modo-historia/etapas/${id}`);
  }

  // Carga masiva de etapas
  static async createEtapasMasivas(
    mundoId: number,
    cantidad: number
  ): Promise<{
    mensaje: string;
    mundoId: number;
    mundoNombre: string;
    ordenInicial: number;
    etapasCreadas: EtapaHistoria[];
  }> {
    const response = await apiClient.post("/modo-historia/etapas/masivas", {
      mundoId,
      cantidad,
    });
    return response.data.data;
  }
}

export const gestionModoHistoriaService = new GestionModoHistoriaService();
